import { put, Success } from './methods';

export default {
  mensagens: {
    liberar: (idEvento: number) => {
      const enpoint = `assembleia/${idEvento}/liberar-mensagens`;
      return put<Success>(enpoint);
    },
    bloquear: (idEvento: number) => {
      const enpoint = `assembleia/${idEvento}/bloquear-mensagens`;
      return put<Success>(enpoint);
    },
  },
  convocar: (idAssembleia: number) => {
    const endpoint = `assembleia/${idAssembleia}/atualizar-convocados`;
    return put<Success>(endpoint);
  },
  bloquear: (idAssembleia: number) => {
    const endpoint = `assembleia/${idAssembleia}/bloquear`;
    return put<Success>(endpoint);
  },
}
